import {newPricingDetails} from '../../utils/constants/signalmanConstants';

class NewPricingDetailsTest {
  constructor() {
    this.flag = newPricingDetails;
    this.fireMetrics();
  }

  fireMetrics() {
    return CustomInk.Metrics.fireEvent(
      'testing',
      '2024 05 01 catalog new pricing details',
      `2024 05 01 catalog new pricing details ${this.flag}`
    );
  }
}

ProductCatalog.NewPricingDetailsTest = new NewPricingDetailsTest();
